<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from "echarts";
import chartResize from "./mixins/chart-resize";

export default {
  name: "barchart",
  mixins: [chartResize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "柱状图",
    },
    chartData: {
      type: Object,
      required: true,
    },
    xAxisName: {
      type: String,
      default: "日期",
    },
    yAxisName: {
      type: String,
      default: "数量",
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.chart.clear();
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions(this.chartData);
    },
    setOptions() {
      this.chart.setOption({
        title: {
          text: this.title,
          textStyle: {
            fontSize: 16,
            color: "#c0c3cd",
          },
        },
        tooltip: {
          show: true,
        },
        legend: {
          show: false,
        },
        grid: {
          top: 35,
          left: "3%",
          right: "6%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          name: this.xAxisName,
          data: this.chartData.days,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#205189",
              width: 3,
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            // interval: 0,
            formatter: function (val) {
              var strs = val.split("");
              var str = "";
              for (var i = 0, s; (s = strs[i++]); ) {
                str += s;
                if (!(i % 8)) str += "\n";
              }
              return str;
            },
            textStyle: {
              color: "#A3C0DF",
            },
          },
        },
        yAxis: [
          {
            name: this.yAxisName,
            type: "value",
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#205189",
                width: 3,
              },
            },
            axisLabel: {
              show: true,
              margin: 14,
              fontSize: 12,
              textStyle: {
                color: "#A3C0DF",
              },
            },
          },
        ],
        series: [
          {
            type: "bar",
            barWidth: 15,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#07ecd9",
                  },
                  {
                    offset: 1,
                    color: "#034881",
                  },
                ]),
              },
            },
            data: this.chartData.data,
            z: 10,
            zlevel: 0,
            label: {
              show: true,
              position: "top",
              distance: 10,
              fontSize: 12,
              color: "#01fff4",
            },
          },
          {
            type: "pictorialBar",
            itemStyle: {
              normal: {
                color: "#0F375F",
              },
            },
            symbolRepeat: "fixed",
            symbolMargin: 6,
            symbol: "rect",
            symbolClip: true,
            symbolSize: [15, 2],
            symbolPosition: "start",
            symbolOffset: [0, -1],
            data: this.chartData.data,
            width: 25,
            z: 0,
            zlevel: 1,
          },
        ],
      });
    },
  },
};
</script>
